<div
  class="universal__shopping__footer__wrapper"
  data-test-id="footerWrapper"
  [attr.data-footer-layout]="layout"
>
  <div class="universal__shopping__footer" data-test-id="footer">
    @if (enrollmentSubfooter?.enable && showStateHeaderFooter) {
      <div
        class="container enrollment__subfooter"
        data-test-id="subfooterWrapper"
      >
        <p class="t-data" data-test-id="subfooterCode">
          {{ enrollmentSubfooter?.code }}
        </p>
        <p class="t-data" data-test-id="subfooterMessage">
          {{ enrollmentSubfooter?.message }}
        </p>
        <p class="t-data" data-test-id="subfooterCodedDate">
          {{ enrollmentSubfooter?.coded_date }}
        </p>
        <p class="t-data" data-test-id="subfooterCopyright">
          {{ enrollmentSubfooter?.copyright }}
        </p>
      </div>
    }

    <div
      class="universal__shopping__footer__content container"
      data-test-id="footerContentWrapper"
    >
      @if (contact1 || contact2) {
        <div
          class="universal__shopping__footer__content__section"
          data-test-id="footerContactContent"
        >
          @if (!useSmallerTitle) {
            <h2
              class="t-bold"
              data-test-id="footerLargerContactTitle"
              [innerHTML]="contactTitle"
            ></h2>
          }
          @if (useSmallerTitle) {
            <h4
              class="t-bold"
              data-test-id="footerSmallerContactTitle"
              [innerHTML]="contactTitle"
            ></h4>
          }
          <div class="model-attribute-group">
            @if (showImg) {
              <img
                data-test-id="footerImage"
                src="https://d1f0xtw5zu5qh9.cloudfront.net/files/36922e34-a750-47d2-a484-262b3319aeeb.png"
                alt="Footer"
                data-test-id="footerCodeImage"
              />
            }
            <div
              class="model-attribute-columns universal__shopping__footer__data-columns"
              data-test-id="footerModelAttributeDataColumnsWrapper"
            >
              @for (col of [contact1, contact2]; track col; let i = $index) {
                @for (config of col.attributes; track config; let j = $index) {
                  <model-attribute
                    class="model-attribute universal__shopping__footer__data-column"
                    [attr.data-test-id]="'footerModelAttributeDataColumn_' + i"
                    [config]="config"
                    [data-test-id]="'footerColumnAttribute_' + i + '_' + j"
                    [attr.style]="getGridAreaStyle(i, j)"
                  ></model-attribute>
                }
              }
            </div>
          </div>
        </div>
      }

      <div
        class="universal__shopping__footer__content__section"
        data-test-id="footerContent"
      >
        <h4 class="t-bold" data-test-id="footerQuickLinksHeaderLabel">
          {{ quickLinksHeaderLabel }}
        </h4>

        @if (quickLinks1?.attributes || quickLinks2?.attributes) {
          <div
            class="quick-links-container"
            data-test-id="footerQuickLinksWrapper"
          >
            <div
              class="quick-links universal__shopping__footer__data-columns"
              data-test-id="footerQuickLinksDataColumnsWrapper"
            >
              @for (
                col of [quickLinks1?.attributes, quickLinks2?.attributes];
                track col;
                let i = $index
              ) {
                @for (link of col; track link; let j = $index) {
                  <p
                    class="universal__shopping__footer__data-column t-data"
                    [attr.data-test-id]="'footerQuickLinksDataColumn_' + i"
                    [attr.style]="getGridAreaStyle(i, j)"
                  >
                    <a
                      class="t-data t-link"
                      [href]="link.value"
                      [attr.aria-label]="link.value"
                      target="_blank"
                      (click)="sendDataAnalytics(link)"
                      [attr.data-test-id]="
                        'footerQuickLinkLabel_' + i + '_' + j
                      "
                      >{{ link.label }}</a
                    >
                  </p>
                }
              }
            </div>
          </div>
        }
      </div>

      @if (contactText) {
        <div
          class="universal__shopping__footer__content__section universal__shopping__footer__text"
          data-test-id="footerContactTextWrapper"
        >
          @for (text of contactText; track text; let i = $index) {
            <p
              class="t-data"
              [attr.data-test-id]="'footerContactText_' + i"
              [innerHtml]="text"
            ></p>
          }
        </div>
      }

      @if (socialMedia) {
        <div
          class="universal__shopping__footer__social universal__shopping__footer__content__section"
          data-test-id="footerSocialMediaContentWrapper"
        >
          @if (socialMedia.facebook) {
            <a
              data-test-id="footerFacebookImageLink"
              [href]="socialMedia.facebook"
              target="_blank"
              aria-label="Facebook"
            >
              <img
                class="icon icon--medium icon--pointer sm--icon"
                data-test-id="footerFacebookImage"
                alt="Facebook"
                data-test-id="footerFacebookImg"
                src="https://d1f0xtw5zu5qh9.cloudfront.net/files/80b82888-5af0-4aff-b06b-dbc13b9a2366.png"
              />
            </a>
          }
          @if (socialMedia.twitter) {
            <a
              data-test-id="footerTwitterImageLink"
              [href]="socialMedia.twitter"
              target="_blank"
              aria-label="Twitter"
            >
              <img
                class="icon icon--medium icon--pointer sm--icon"
                data-test-id="footerTwitterImage"
                alt="Twitter"
                data-test-id="footerTwitterImg"
                src="https://d1f0xtw5zu5qh9.cloudfront.net/files/2991d83e-4368-434f-9c8c-6dd7210c56bc.png"
              />
            </a>
          }
          @if (socialMedia.instagram) {
            <a
              data-test-id="footerInstagramImageLink"
              [href]="socialMedia.instagram"
              target="_blank"
              aria-label="Instagram"
            >
              <img
                class="icon icon--medium icon--pointer sm--icon"
                data-test-id="footerInstagramImage"
                alt="Instagram"
                data-test-id="footerInstagramImg"
                src="https://d1f0xtw5zu5qh9.cloudfront.net/files/045fdc48-53a3-4b8c-979f-edfb1a344f3a.png"
              />
            </a>
          }
        </div>
      }
    </div>
  </div>

  <div
    class="universal__shopping__sub__footer"
    data-test-id="subfooterCopyrightContentWrapper"
  >
    <div class="universal__shopping__sub__footer__content container">
      <p
        class="t-data"
        data-test-id="subfooterCopyrightText"
        [innerHTML]="'© ' + copyright.text"
      ></p>
      <a
        tabindex="-1"
        aria-label="Copyright Url"
        href="https://www.trustarc.com/consumer-resources/dispute-resolution-2/"
        target="_blank"
        data-test-id="subfooterCopyrightUrl"
      >
        @if (copyright.image && copyright.image === 'TRUSTe') {
          <img
            data-test-id="subfooterCopyrightImage"
            [attr.alt]="copyright.image"
            data-test-id="footerCopyRightImg"
            src="https://d1f0xtw5zu5qh9.cloudfront.net/files/e7ca7470-e072-496e-9f0a-b7b3e1e7cf83.png"
          />
        }
      </a>
    </div>
  </div>
</div>
